import React, { useState } from 'react';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { api_host } from '../apiClient';
import { useAppContext } from '../utils/AppContext';
import CreateCampaign from './CreateCampaign';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import Badge from '@mui/material/Badge';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import MyCampaignTableModal from './MyCampaignTableModal';
import DownloadStatusModal from './DownloadStatusModal';
import UpdateDatabase from './UpdateDatabase';
import { isExportJobActive } from '../apiClient/fetchExportJobs';
import { useExportJobs } from '../hooks/useExportJobs';

interface HeaderProps {
  setUpdateCampaignFilter: Function;
}

const Header = (props: HeaderProps) => {
  const { setUpdateCampaignFilter } = props;

  const context = useAppContext();
  const { watchedEntries, activeCount, openDownloadStatusModal } = useExportJobs();
  const watchedActiveCount = watchedEntries.filter(
    (e) => !e.job || isExportJobActive(e.job),
  ).length;
  const badgeCount = watchedActiveCount > 0 ? watchedActiveCount : activeCount;

  const [showMyCampaignModal, setShowMyCampaignModal] = useState<boolean>(false);

  const loginTitle = (
    <>
      <AccountCircleIcon /> {context?.username}
    </>
  );

  const handleCampaignList = () => {
    setShowMyCampaignModal(true);
  };

  const downloadStatusLabel = (
    <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 1 }}>
      {badgeCount > 0 && (
        <CircularProgress size={14} color="inherit" aria-hidden />
      )}
      <Badge
        badgeContent={badgeCount}
        color="primary"
        invisible={badgeCount === 0}
        sx={{ '& .MuiBadge-badge': { right: -4, top: 2 } }}
      >
        <span>Download Status</span>
      </Badge>
    </Box>
  );

  return (
    <Navbar expand="lg" className="bg-body-tertiary" style={{ overflow: 'visible' }}>
      <div
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          alignItems: 'center',
          marginLeft: '2.5%',
          marginRight: '2.5%',
        }}
      >
        <Navbar.Brand href="/">
          <img
            src="/favicon.png"
            width={30}
            style={{ marginRight: '0.5em' }}
            alt="SigCap"
          />{' '}
          SigCap Data Visualization
        </Navbar.Brand>
        {context?.username && (
          <Navbar.Brand
            style={{
              marginLeft: 'auto',
            }}
          >
            <CreateCampaign
              styleOverrides={{}}
              disabled={context?.username == null}
              setUpdateCampaignFilter={setUpdateCampaignFilter}
            />
          </Navbar.Brand>
        )}
        {context?.username && context?.isSuperuser && (
          <Navbar.Brand
            style={{
              marginLeft: '1em',
            }}
          >
            <UpdateDatabase
              styleOverrides={{}}
              disabled={context?.username == null}
            />
          </Navbar.Brand>
        )}
        <Navbar.Brand
          style={{
            marginLeft: context?.username == null ? 'auto' : '0',
          }}
        >
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              {context?.username ? (
                <NavDropdown
                  title={loginTitle}
                  id="basic-nav-dropdown"
                  align="end"
                >
                  <NavDropdown.Item onClick={handleCampaignList}>
                    My Campaigns
                  </NavDropdown.Item>
                  <NavDropdown.Item onClick={openDownloadStatusModal}>
                    {downloadStatusLabel}
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/admin/dashboard">
                    Statistics
                  </NavDropdown.Item>
                  <NavDropdown.Item href={api_host + '/accounts/logout'}>
                    Logout
                  </NavDropdown.Item>
                </NavDropdown>
              ) : (
                <Nav.Link href={api_host + '/accounts/login'}>
                  <Button variant="contained">Login</Button>
                </Nav.Link>
              )}
            </Nav>
          </Navbar.Collapse>
        </Navbar.Brand>
        {context?.username && (
          <MyCampaignTableModal
            showMyCampaignModal={showMyCampaignModal}
            setShowMyCampaignModal={setShowMyCampaignModal}
            setUpdateCampaignFilter={setUpdateCampaignFilter}
          />
        )}
        {context?.username && <DownloadStatusModal />}
      </div>
    </Navbar>
  );
};

export default Header;
